module.exports = __webpack_public_path__ + "static/media/合同管理.63fbbf8b.png";